module.exports = __webpack_public_path__ + "img/programmer.949ede53.svg";